var Store =
webpackJsonp_store([6],{

/***/ "3XIZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
exports.WaitFreeTimer = void 0;
var React = __webpack_require__("SAdv");
var moment = __webpack_require__("pQse");
var rsg_1 = __webpack_require__("KKT9");
var WaitFreeTimer = /** @class */ (function (_super) {
    __extends(WaitFreeTimer, _super);
    function WaitFreeTimer(props) {
        var _this = _super.call(this, props) || this;
        _this.state = _this.getUpdatedState();
        return _this;
    }
    WaitFreeTimer.prototype.getUpdatedState = function () {
        var _this = this;
        var availableAt = moment(this.props.availableAt);
        var duration = moment.duration(availableAt.diff(moment()));
        var milliseconds = duration.as('milliseconds');
        var units = ['일', '시간', '분'];
        if (milliseconds < 1000) {
            this.props.close();
            return;
        }
        var milliSecondsToNextMin = milliseconds % 60000;
        this.timeout = window.setTimeout(function () {
            var state = _this.getUpdatedState();
            state && _this.setState(state);
        }, milliSecondsToNextMin);
        if (milliSecondsToNextMin > 0) {
            duration.add(1, 'm');
        }
        return {
            duration: duration,
            remaining: [
                duration.days(),
                duration.hours(),
                duration.minutes(),
            ].reduce(function (acc, cur, i) {
                cur && acc.push(cur + units[i]);
                return acc;
            }, []).join(' '),
            ratio: duration.as('hours') / this.props.intervalHours,
        };
    };
    WaitFreeTimer.prototype.componentWillUnmount = function () {
        window.clearTimeout(this.timeout);
    };
    WaitFreeTimer.prototype.render = function () {
        return (React.createElement("div", { className: "BookDetailWaitFree_Timer" },
            React.createElement(rsg_1.Icon, { name: "clock_1", className: "BookDetailWaitFree_Timer_Icon" }),
            React.createElement("span", { className: "BookDetailWaitFree_Timer_Remaining" },
                this.state.remaining,
                " \uB0A8\uC74C"),
            React.createElement("div", { className: "BookDetailWaitFree_Timer_ProgressBar" },
                React.createElement("div", { className: "BookDetailWaitFree_Timer_ProgressBar_Filled", style: { width: (1 - this.state.ratio) * 100 + "%" } }))));
    };
    return WaitFreeTimer;
}(React.Component));
exports.WaitFreeTimer = WaitFreeTimer;
;


/***/ }),

/***/ "46aP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
exports.NoticeSelect = void 0;
var React = __webpack_require__("SAdv");
var classnames_1 = __webpack_require__("C7vi");
var rsg_1 = __webpack_require__("KKT9");
exports.NoticeSelect = function (props) {
    var haveRidiSelectBookInSetBooks = props.haveRidiSelectBookInSetBooks, setBookElementId = props.setBookElementId, isRidiSelectBook = props.isRidiSelectBook, ridiSelectDetailUrl = props.ridiSelectDetailUrl;
    var infoTitle = haveRidiSelectBookInSetBooks
        ? '리디셀렉트에서 볼 수 있는 책이 포함되어 있습니다.'
        : isRidiSelectBook
            ? '리디셀렉트에서 바로 볼 수 있는 책입니다!'
            : '';
    var anchorHref = haveRidiSelectBookInSetBooks ? "#" + setBookElementId : isRidiSelectBook ? ridiSelectDetailUrl : null;
    if (!haveRidiSelectBookInSetBooks && !isRidiSelectBook)
        return null;
    return (React.createElement("div", { className: "BookDetailNotice_List" },
        React.createElement("div", { className: classnames_1["default"]('BookDetailNotice_List_Header', 'BookDetailNotice_List_Header-select') }, "\uC140\uB809\uD2B8"),
        React.createElement("div", { className: "BookDetailNotice_List_Group" },
            React.createElement("div", { className: "BookDetailNotice_List_Item BookDetailNotice_List_Item-event" },
                React.createElement("a", { className: "BookDetailNotice_Select_Link", href: anchorHref },
                    React.createElement("div", { className: "BookDetailNotice_List_Item_Title" }, infoTitle),
                    React.createElement(rsg_1.Icon, { className: "BookDetailNotice_List_Item_ArrowIcon", name: "arrow_2_right" }))))));
};


/***/ }),

/***/ "64nv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
exports.__esModule = true;
exports.NoticeLinkedContentsItem = void 0;
/** @jsx jsx */
var React = __webpack_require__("SAdv");
var classNames = __webpack_require__("C7vi");
var core_1 = __webpack_require__("Hy8z");
var colors_1 = __webpack_require__("xP39");
var core_2 = __webpack_require__("Hy8z");
var types_1 = __webpack_require__("UCpW");
var hooks_1 = __webpack_require__("B3px");
var BookDetailContext_1 = __webpack_require__("zCUy");
var LinkedContentsPopup_1 = __webpack_require__("P6Ru");
function NoticeLinkedContentsItem(_a) {
    var contents = _a.item;
    var bookId = React.useContext(BookDetailContext_1.BookDetailContext).bookId;
    var contentsExceptMe = contents.filter(function (content) {
        return types_1.isAnimationContent(content) || content.book_id !== "" + bookId;
    });
    if (contentsExceptMe.length === 0) {
        return null;
    }
    //@ts-ignore
    var isMobile = global.Ridi.globals.isMobile;
    var anchorStyle = core_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n    display: flex;\n    background: transparent;\n    justify-content: space-between;\n    align-items: center;\n    svg {\n      padding-right: ", ";\n    }\n\n    :hover {\n      h5 {\n        color: ", ";\n      }\n    }\n  "], ["\n    width: 100%;\n    display: flex;\n    background: transparent;\n    justify-content: space-between;\n    align-items: center;\n    svg {\n      padding-right: ", ";\n    }\n\n    :hover {\n      h5 {\n        color: ", ";\n      }\n    }\n  "])), isMobile ? '0' : '9px', colors_1.dodgerBlue40);
    var popupRef = React.useRef();
    if (contentsExceptMe.length >= 2) {
        return (core_2.jsx("li", { className: classNames('BookDetailNotice_List_Item') },
            core_2.jsx("button", { css: anchorStyle, onClick: function () { var _a, _b; return (_b = (_a = popupRef.current) === null || _a === void 0 ? void 0 : _a.open) === null || _b === void 0 ? void 0 : _b.call(_a); } },
                core_2.jsx("div", { className: "BookDetailNotice_List_Item_Title" }, "\uC774 \uC791\uD488 \uB2E4\uC591\uD558\uAC8C \uC990\uAE30\uAE30"),
                core_2.jsx("span", { className: "BookDetailNotice_List_Item_TipText" },
                    contents.length,
                    " \uC791\uD488")),
            core_2.jsx(LinkedContentsPopup_1.LinkedContentsPopup, { className: classNames('LinkedContentsPopup'), contents: contents, ref: popupRef })));
    }
    var firstContent = contentsExceptMe[0];
    var _b = hooks_1.useLinkedContentLink(firstContent), link = _b.link, target = _b.target, onClick = _b.onClick;
    return (core_2.jsx("li", { className: classNames('BookDetailNotice_List_Item') },
        core_2.jsx("a", { css: anchorStyle, href: link, target: target, onClick: onClick },
            core_2.jsx("div", { className: "BookDetailNotice_List_Item_Title" }, types_1.isAnimationContent(firstContent) ?
                '라프텔에서 애니메이션으로 보기' :
                firstContent.extra_book_metadata.mapped_category.text))));
}
exports.NoticeLinkedContentsItem = NoticeLinkedContentsItem;
;
var templateObject_1;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("Pkug")))

/***/ }),

/***/ "7aFn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
exports.NoticeItem = void 0;
var React = __webpack_require__("SAdv");
var classNames = __webpack_require__("C7vi");
var rsg_1 = __webpack_require__("KKT9");
var NoticeItem = /** @class */ (function (_super) {
    __extends(NoticeItem, _super);
    function NoticeItem(props) {
        var _this = _super.call(this, props) || this;
        _this.handleToggle = function () {
            if (!_this.state.expandable) {
                return;
            }
            _this.setState(function (prevState) {
                return { expanded: !prevState.expanded };
            });
        };
        _this.state = {
            expandable: !!_this.props.item.content,
            expanded: false,
        };
        return _this;
    }
    NoticeItem.prototype.render = function () {
        var item = this.props.item;
        var _a = this.state, expandable = _a.expandable, expanded = _a.expanded;
        return (React.createElement("li", { className: classNames('BookDetailNotice_List_Item', 'BookDetailNotice_List_Item-notice', {
                'BookDetailNotice_List_Item-expandable': expandable,
                'BookDetailNotice_List_Item-expanded': expanded,
            }), onClick: this.handleToggle },
            React.createElement("div", { className: "BookDetailNotice_List_Item_Title" },
                item.title,
                expandable && (React.createElement(rsg_1.Icon, { className: "BookDetailNotice_List_Item_ArrowIcon", name: expanded ? 'arrow_2_up' : 'arrow_2_down' }))),
            expanded && (React.createElement("p", { className: "BookDetailNotice_List_Item_Content", dangerouslySetInnerHTML: { __html: item.content } }))));
    };
    return NoticeItem;
}(React.Component));
exports.NoticeItem = NoticeItem;


/***/ }),

/***/ "B3px":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
exports.useLinkedContentLink = void 0;
var types_1 = __webpack_require__("UCpW");
var react_1 = __webpack_require__("SAdv");
var BookDetailContext_1 = __webpack_require__("zCUy");
var BookTrackingWrapper_1 = __webpack_require__("h36S");
exports.useLinkedContentLink = function (content, idx) {
    var categoryName = react_1.useContext(BookDetailContext_1.BookDetailContext).categoryName;
    if (types_1.isAnimationContent(content)) {
        var utmParams = "?utm_medium=referral&utm_source=ridi&utm_campaign=" + encodeURIComponent(categoryName);
        // 라프텔 링크는 유니버설 링크로 제공한다
        var fallbackLink_1 = "https://laftel.net/item/" + content.laftel_id + utmParams;
        var deepLink_1 = "laftel://item/" + content.laftel_id + "/" + utmParams;
        // iOS에서는 apple-app-site-association 을 통해서 fallback링크도 딥 링크로 작동
        var needsDeepLink = navigator.userAgent.includes('Android');
        var onClick = needsDeepLink ? function (event) {
            event.preventDefault();
            location.href = deepLink_1;
            setTimeout(function () { return location.href = fallbackLink_1; }, 2000);
        } : undefined;
        return { link: fallbackLink_1, target: '_blank', onClick: onClick };
    }
    var uri = BookTrackingWrapper_1.getTrackingURI("/books/" + content.book_id, {
        sectionId: 'linked_contents',
        sectionItemIdx: idx,
    });
    return { link: uri };
};


/***/ }),

/***/ "H8dE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
exports.__esModule = true;
var React = __webpack_require__("SAdv");
var styled_1 = __webpack_require__("LJ3e");
var colors_1 = __webpack_require__("xP39");
var WaitFree_svg_1 = __webpack_require__("O3Ee");
;
var Badge = styled_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", "px;\n  height: ", "px;\n  border-radius: ", "px;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2;\n  background: ", ";\n\n  & > img, svg {\n    width: ", "px;\n    height: ", "px;\n  }\n\n  & > span {\n    font-size: ", "px;\n  }\n"], ["\n  width: ", "px;\n  height: ", "px;\n  border-radius: ", "px;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2;\n  background: ", ";\n\n  & > img, svg {\n    width: ", "px;\n    height: ", "px;\n  }\n\n  & > span {\n    font-size: ", "px;\n  }\n"])), function (props) { return props.size; }, function (props) { return props.size; }, function (props) { return props.size; }, function (props) { return props.backgroundColor; }, function (props) { return Math.round(props.size * 20 / 34); }, function (props) { return Math.round(props.size * 18 / 34); }, function (props) { return props.size * 13 / 34; });
// @ts-ignore
var WaitFree = styled_1["default"](WaitFree_svg_1["default"])(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  left: 1px;\n  z-index: 2;\n"], ["\n  position: relative;\n  left: 1px;\n  z-index: 2;\n"])));
var Rentable = styled_1["default"].span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: relative;\n  font-weight: bold;\n  line-height: 14px;\n  color: #ffffff;\n  z-index: 2;\n"], ["\n  position: relative;\n  font-weight: bold;\n  line-height: 14px;\n  color: #ffffff;\n  z-index: 2;\n"])));
var DiscountPercentage = styled_1["default"].span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  top: 1.6px;\n  transform: scale(0.92);\n  font-weight: bold;\n  margin-left: 0.7px;\n  font-size: 0.846em;\n  position: relative;\n  line-height: 0.692em;\n"], ["\n  top: 1.6px;\n  transform: scale(0.92);\n  font-weight: bold;\n  margin-left: 0.7px;\n  font-size: 0.846em;\n  position: relative;\n  line-height: 0.692em;\n"])));
var DiscountBadge = styled_1["default"](Badge)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  position: relative;\n  color: white;\n"], ["\n  position: relative;\n  color: white;\n"])));
var DiscountNumber = styled_1["default"].span(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  font-size: 1.231em;\n  mix-blend-mode: normal;\n  font-weight: bold;\n  line-height: 1.077em;\n  opacity: 0.99;\n"], ["\n  font-size: 1.231em;\n  mix-blend-mode: normal;\n  font-weight: bold;\n  line-height: 1.077em;\n  opacity: 0.99;\n"])));
var BookBadgeRenderer = function (props) {
    var _a = props.size, size = _a === void 0 ? 34 : _a, isWaitFree = props.isWaitFree, discountPercentage = props.discountPercentage, isRentable = props.isRentable;
    if (isRentable) {
        return (
        // @ridi/colors 패키지 업데이트 후 'sea_green' 으로 바꾸기
        React.createElement(Badge, { className: "badge", backgroundColor: "#3ea590", size: size },
            React.createElement(Rentable, null, "\uB300\uC5EC")));
    }
    if (isWaitFree) {
        return (React.createElement(Badge, { className: "badge", backgroundColor: colors_1.dodgerBlue50, size: size },
            React.createElement(WaitFree, { viewBox: "0 0 20 18", preserveAspectRatio: "xMidYMid meet", "aria-label": "\uB9AC\uB514 \uAE30\uB2E4\uB9AC\uBA74 \uBB34\uB8CC" })));
    }
    if (discountPercentage && discountPercentage >= 10) {
        return (React.createElement(DiscountBadge, { className: "badge", backgroundColor: colors_1.blueGray40, role: "img", "aria-label": discountPercentage + "% \uD560\uC778", size: size },
            React.createElement(DiscountNumber, null, discountPercentage),
            React.createElement(DiscountPercentage, null, "%")));
    }
    return null;
};
exports["default"] = BookBadgeRenderer;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;


/***/ }),

/***/ "O3Ee":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("SAdv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 9c0 4.962 3.98 9 8.872 9 2.12 0 4.17-.77 5.777-2.169a1.027 1.027 0 00.108-1.435.992.992 0 00-1.414-.11 6.807 6.807 0 01-4.471 1.679c-3.786 0-6.867-3.126-6.867-6.965 0-3.84 3.081-6.965 6.867-6.965 3.544 0 6.468 2.737 6.83 6.236l-.677-.86a.992.992 0 00-1.41-.162c-.433.35-.504.99-.159 1.43l2.734 3.482 3.432-2.774c.433-.349.505-.99.16-1.429a.992.992 0 00-1.41-.162l-.66.534C17.37 3.68 13.541 0 8.871 0 3.98 0 0 4.037 0 9zm7-3.02v4.98l3.996.04h.01a.988.988 0 00.994-.97.987.987 0 00-.985-.989l-2.025-.02v-3.04A.988.988 0 007.994 5 .987.987 0 007 5.98z",
  fill: "#fff"
});

var SvgWaitFree = function SvgWaitFree(props) {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    width: 20,
    height: 18,
    fill: "none"
  }, props), _ref);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgWaitFree);

/***/ }),

/***/ "P6Ru":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var _a, _b;
exports.__esModule = true;
exports.LinkedContentsPopup = void 0;
/** @jsx jsx */
var React = __webpack_require__("SAdv");
var styled_1 = __webpack_require__("LJ3e");
var BookBadgeRenderer_1 = __webpack_require__("H8dE");
var core_1 = __webpack_require__("Hy8z");
var colors_1 = __webpack_require__("xP39");
var PortraitBook_1 = __webpack_require__("n8nK");
var web_ui_1 = __webpack_require__("8TRf");
var BookDetailContext_1 = __webpack_require__("zCUy");
var rsg_1 = __webpack_require__("KKT9");
var Popup_1 = __webpack_require__("h+sG");
var types_1 = __webpack_require__("UCpW");
var hooks_1 = __webpack_require__("B3px");
//@ts-ignore
var FALLBACK_COVER_URL = ((_b = (_a = global.Ridi) === null || _a === void 0 ? void 0 : _a.globals) === null || _b === void 0 ? void 0 : _b.staticUrl) + '/books/dist/images/book_cover/cover_lazyload.png';
var LaftelCover = styled_1["default"].img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 50px;\n  height: auto;\n"], ["\n  width: 50px;\n  height: auto;\n"])));
var LinkedContentThumbnailWrapper = styled_1["default"].div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  flex: 0 0 auto;\n"], ["\n  flex: 0 0 auto;\n"])));
var LinkedContentThumbnail = function (_a) {
    var _b;
    var content = _a.content;
    var _c = React.useContext(BookDetailContext_1.BookDetailContext), isVerifiedAdult = _c.isVerifiedAdult, adultBookCover = _c.adultBookCover;
    var _d = React.useState((function () {
        var _a, _b;
        if (types_1.isAnimationContent(content)) {
            return content.cover;
        }
        return (content.adults_only && !isVerifiedAdult) ?
            adultBookCover :
            (((_b = (_a = content.serial) === null || _a === void 0 ? void 0 : _a.cover) === null || _b === void 0 ? void 0 : _b.xxlarge) || content.cover.xxlarge);
    })()), thumbnailUrl = _d[0], setThumbnailUrl = _d[1];
    var thumbnailErrorRef = React.useRef(null);
    React.useEffect(function () {
        if (!thumbnailErrorRef.current) {
            return;
        }
        var onErrorHandler = function () { return setThumbnailUrl(FALLBACK_COVER_URL); };
        thumbnailErrorRef.current.addEventListener('error', onErrorHandler, true);
        return function () {
            thumbnailErrorRef.current.removeEventListener('error', onErrorHandler);
        };
    }, []);
    if (types_1.isAnimationContent(content)) {
        return (core_1.jsx(LinkedContentThumbnailWrapper, null,
            core_1.jsx(LaftelCover, { ref: thumbnailErrorRef, src: thumbnailUrl, alt: "\uC560\uB2C8\uBA54\uC774\uC158\uC73C\uB85C \uBCF4\uAE30" })));
    }
    return (core_1.jsx(LinkedContentThumbnailWrapper, { ref: thumbnailErrorRef },
        core_1.jsx(web_ui_1.Book.Thumbnail, { thumbnailUrl: thumbnailUrl, thumbnailWidth: 50, adultBadge: content.adults_only },
            core_1.jsx(PortraitBook_1.BadgeContainer, null,
                core_1.jsx(BookBadgeRenderer_1["default"], { size: 20, isWaitFree: !!((_b = content === null || content === void 0 ? void 0 : content.serial) === null || _b === void 0 ? void 0 : _b.wait_for_free) })))));
};
var LinkedContentItemWrapper = styled_1["default"].a(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  min-height: 75px;\n  margin: 8px 0;\n\n  &:first-of-type {\n    margin-top: 0;\n  }\n\n  &:last-of-type {\n    margin-bottom: 0;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  min-height: 75px;\n  margin: 8px 0;\n\n  &:first-of-type {\n    margin-top: 0;\n  }\n\n  &:last-of-type {\n    margin-bottom: 0;\n  }\n"])));
var LinkedContentItemBody = styled_1["default"].div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  padding: 0 11px;\n  width: 196px;\n  box-sizing: border-box;\n"], ["\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  padding: 0 11px;\n  width: 196px;\n  box-sizing: border-box;\n"])));
var LinkedContentItemTitle = styled_1["default"].span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 13px;\n  letter-spacing: -0.06px;\n  margin-bottom: 5px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"], ["\n  color: ", ";\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 13px;\n  letter-spacing: -0.06px;\n  margin-bottom: 5px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])), colors_1.gray40);
var LinkedContentItemText = styled_1["default"].span(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 15px;\n  letter-spacing: -0.07px;\n"], ["\n  color: ", ";\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 15px;\n  letter-spacing: -0.07px;\n"])), colors_1.gray90);
var LinkedContentItemIcon = styled_1["default"](rsg_1.Icon)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  flex: 0 0 auto;\n  width: 10px;\n  height: 10px;\n  fill: ", ";\n"], ["\n  flex: 0 0 auto;\n  width: 10px;\n  height: 10px;\n  fill: ", ";\n"])), colors_1.gray60);
var LinkedContentItem = function (_a) {
    var _b, _c;
    var content = _a.content, index = _a.index;
    var title = types_1.isAnimationContent(content) ?
        content.title : (_c = (_b = content.serial) === null || _b === void 0 ? void 0 : _b.title) !== null && _c !== void 0 ? _c : content.title;
    var text = types_1.isAnimationContent(content) ?
        '애니메이션으로 보기' :
        content.extra_book_metadata.mapped_category.text;
    var _d = hooks_1.useLinkedContentLink(content, index), link = _d.link, target = _d.target, onClick = _d.onClick;
    return (core_1.jsx(LinkedContentItemWrapper, { href: link, onClick: onClick, target: target },
        core_1.jsx(LinkedContentThumbnail, { content: content }),
        core_1.jsx(LinkedContentItemBody, null,
            core_1.jsx(LinkedContentItemTitle, null, title),
            core_1.jsx(LinkedContentItemText, null, text)),
        core_1.jsx(LinkedContentItemIcon, { name: "arrow_2_right" })));
};
var LinkedContentsPopupWrapper = styled_1["default"].div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  padding: 16px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  padding: 16px;\n"])));
;
exports.LinkedContentsPopup = React.forwardRef(function (_a, ref) {
    var className = _a.className, contents = _a.contents;
    return (core_1.jsx("div", { className: className },
        core_1.jsx(Popup_1.Popup, { title: "", ref: ref },
            core_1.jsx(LinkedContentsPopupWrapper, null, contents.map(function (content, index) { return (core_1.jsx(LinkedContentItem, { content: content, index: index, key: types_1.isAnimationContent(content) ? "laftel-" + content.laftel_id : "book-" + content.book_id })); })))));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("Pkug")))

/***/ }),

/***/ "Q7pf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.NoticeList = void 0;
var classNames = __webpack_require__("C7vi");
var React = __webpack_require__("SAdv");
var Notice_1 = __webpack_require__("Umsz");
var NoticeItem_1 = __webpack_require__("7aFn");
var NoticeBenefitItem_1 = __webpack_require__("uYbG");
var NoticeEventItem_1 = __webpack_require__("RCbT");
var NoticeLinkedContentsItem_1 = __webpack_require__("64nv");
var styled_1 = __webpack_require__("LJ3e");
var ShowMore = styled_1["default"].li(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 5px 0;\n  font-size: 12px;\n  cursor: pointer;\n  button {\n    font-size: 12px;\n    color: #808991;\n  }\n"], ["\n  padding: 5px 0;\n  font-size: 12px;\n  cursor: pointer;\n  button {\n    font-size: 12px;\n    color: #808991;\n  }\n"])));
function NoticeList(props) {
    var header = props.header, type = props.type, items = props.items;
    var _a = React.useState(false), isToggled = _a[0], setToggle = _a[1];
    var renderItems = function (item, index) {
        var key = type + "-" + index;
        switch (type) {
            case Notice_1.DisplayType.LINKED_CONTENTS: {
                return (React.createElement(NoticeLinkedContentsItem_1.NoticeLinkedContentsItem, { item: item, key: key }));
            }
            case Notice_1.DisplayType.EVENTS: {
                return React.createElement(NoticeEventItem_1.NoticeEventItem, { event: item, key: key });
            }
            case Notice_1.DisplayType.BENEFIT: {
                return React.createElement(NoticeBenefitItem_1.NoticeBenefitItem, __assign({}, item, { key: key }));
            }
            default: {
                return (React.createElement(NoticeItem_1.NoticeItem, { item: item, key: key }));
            }
        }
    };
    // 이벤트가 3개 초과면 토글하는 기능
    function renderToggleItems() {
        if (items.length < 1 || type !== 'events') {
            return null;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("ul", { className: "BookDetailNotice_List_Group" }, items.slice(0, !isToggled ? 2 : items.length).map(function (item, index) {
                return renderItems(item, index);
            })),
            !isToggled && items.length > 2 &&
                React.createElement("ul", { className: "BookDetailNotice_List_Group" },
                    React.createElement(ShowMore, { onClick: function () { return setToggle(true); } },
                        React.createElement("button", { role: "button" }, "\uC774\uBCA4\uD2B8 \uB354\uBCF4\uAE30")))));
    }
    return items && items.length ? (React.createElement("div", { className: "BookDetailNotice_List" },
        React.createElement("div", { className: classNames('BookDetailNotice_List_Header', "BookDetailNotice_List_Header-" + type) }, header),
        type !== 'events' ?
            React.createElement("ul", { className: "BookDetailNotice_List_Group" }, items.map(function (item, index) {
                return renderItems(item, index);
            }))
            : renderToggleItems())) : null;
}
exports.NoticeList = NoticeList;
;
var templateObject_1;


/***/ }),

/***/ "RCbT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
exports.NoticeEventItem = void 0;
var React = __webpack_require__("SAdv");
var classNames = __webpack_require__("C7vi");
var moment = __webpack_require__("pQse");
var rsg_1 = __webpack_require__("KKT9");
function NoticeEventItem(props) {
    var _a = props.event, eventId = _a.eventId, groupName = _a.groupName, startDate = _a.startDate, endDate = _a.endDate;
    var start = moment(new Date(startDate)).locale('ko');
    var end = moment(new Date(endDate)).locale('ko');
    var periodExposure = moment.isMoment(start) && end.diff(moment(), 'years') < 2;
    return (React.createElement("li", { className: classNames('BookDetailNotice_List_Item', 'BookDetailNotice_List_Item-event', { 'BookDetailNotice_List_Item-hasPeriod': periodExposure }) },
        React.createElement("a", { href: "/event/" + eventId },
            React.createElement("div", { className: "BookDetailNotice_List_Item_Title" }, groupName),
            React.createElement(rsg_1.Icon, { className: "BookDetailNotice_List_Item_ArrowIcon", name: "arrow_2_right" }))));
}
exports.NoticeEventItem = NoticeEventItem;
;


/***/ }),

/***/ "UCpW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
exports.isAnimationContent = exports.isV2ResponseSuccess = void 0;
;
exports.isV2ResponseSuccess = function (response) {
    return response.success;
};
exports.isAnimationContent = function (content) {
    var laftelId = content.laftel_id;
    return laftelId !== null && laftelId !== undefined;
};


/***/ }),

/***/ "UE1o":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var React = __webpack_require__("SAdv");
var ReactDOM = __webpack_require__("CSY6");
var object_case_converter_1 = __webpack_require__("7Sv+");
var BookDetailContext_1 = __webpack_require__("zCUy");
var Notice_1 = __webpack_require__("Umsz");
/*
  도서 상세에 표시되는
  혜택, 리다무, 셀렉트, 라프텔, 공지, 연재, 이벤트 에 대해 정리가 필요함.
  현재는 정보 출처도 혼동되고 코드도 엉망
 */
window.addEventListener('bookDetailLoad', function (event) {
    var _a = event.detail, noticeTargetElementId = _a.noticeTargetElementId, selectInfoTargetElementId = _a.selectInfoTargetElementId, events = _a.events, bookId = _a.bookId, bookApiUrl = _a.bookApiUrl, apiServerUrl = _a.apiServerUrl, haveRidiSelectBookInSetBooks = _a.haveRidiSelectBookInSetBooks, setBookElementId = _a.setBookElementId, isRidiSelectBook = _a.isRidiSelectBook, categoryName = _a.categoryName, ridiSelectDetailUrl = _a.ridiSelectDetailUrl, bookBenefits = _a.bookBenefits, isVerifiedAdult = _a.isVerifiedAdult, adultBookCover = _a.adultBookCover, featureGuard = _a.featureGuard;
    var detailContext = {
        bookId: bookId,
        categoryName: categoryName,
        bookApiUrl: bookApiUrl,
        apiServerUrl: apiServerUrl,
        isVerifiedAdult: isVerifiedAdult,
        adultBookCover: adultBookCover,
        featureGuard: featureGuard,
    };
    var target = document.getElementById(noticeTargetElementId);
    if (!target) {
        return;
    }
    ReactDOM.render(React.createElement(BookDetailContext_1.BookDetailContext.Provider, { value: detailContext },
        React.createElement("ul", { className: "NoticeWrapper" },
            React.createElement(Notice_1.Notice, { events: object_case_converter_1.camelize(events), benefits: bookBenefits, haveRidiSelectBookInSetBooks: haveRidiSelectBookInSetBooks, setBookElementId: setBookElementId, isRidiSelectBook: isRidiSelectBook, ridiSelectDetailUrl: ridiSelectDetailUrl }))), target);
    // ** Select도 Notice쪽으로 컴포넌트 병합시켰음
    // ReactDOM.render(
    //   <SelectInfo
    //     haveRidiSelectBookInSetBooks={haveRidiSelectBookInSetBooks}
    //     setBookElementId={setBookElementId}
    //     isRidiSelectBook={isRidiSelectBook}
    //     ridiSelectDetailUrl={ridiSelectDetailUrl}
    //   />,
    //   document.getElementById(selectInfoTargetElementId),
    // );
});


/***/ }),

/***/ "Umsz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
exports.__esModule = true;
exports.Notice = exports.DisplayType = exports.ItemType = void 0;
var React = __webpack_require__("SAdv");
var axios_1 = __webpack_require__("gI3o");
var types_1 = __webpack_require__("UCpW");
var BookDetailContext_1 = __webpack_require__("zCUy");
var NoticeList_1 = __webpack_require__("Q7pf");
var NoticeSelect_1 = __webpack_require__("46aP");
var WaitFree_1 = __webpack_require__("w0AC");
var ItemType;
(function (ItemType) {
    ItemType["NOTICE_NORMAL"] = "NOTICE_NORMAL";
    ItemType["SERIAL_SCHEDULE"] = "SERIAL_SCHEDULE";
    ItemType["CURRENT_SERIAL_SCHEDULE"] = "CURRENT_SERIAL_SCHEDULE";
    ItemType["SERIAL_DELAYED"] = "SERIAL_DELAYED";
    ItemType["SERIAL_DELAYED_BY_AUTHOR"] = "SERIAL_DELAYED_BY_AUTHOR";
    ItemType["DEPRECATED_NOTICE_LAFTEL_CONTENTS"] = "NOTICE_LAFTEL_CONTENTS";
})(ItemType = exports.ItemType || (exports.ItemType = {}));
var DisplayType;
(function (DisplayType) {
    DisplayType["SCHEDULE"] = "schedule";
    DisplayType["NOTICE"] = "notices";
    DisplayType["EVENTS"] = "events";
    DisplayType["BENEFIT"] = "benefits";
    DisplayType["LINKED_CONTENTS"] = "linkedContents";
})(DisplayType = exports.DisplayType || (exports.DisplayType = {}));
var Notice = /** @class */ (function (_super) {
    __extends(Notice, _super);
    function Notice(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            schedule: [],
            notices: [],
            events: props.events,
            benefits: props.benefits,
            linkedContents: []
        };
        return _this;
    }
    // TODO: use redux store
    Notice.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.context, bookApiUrl = _a.bookApiUrl, apiServerUrl = _a.apiServerUrl, bookId = _a.bookId;
        axios_1["default"]
            .get(bookApiUrl + "/books/" + bookId + "/notices")
            .then(function (response) {
            var _a, _b;
            var notices = (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.notices) !== null && _b !== void 0 ? _b : [];
            var result = notices.reduce(function (acc, item) {
                return Notice.parseNoticeType(acc, item);
            }, {});
            _this.setState(result);
        });
        axios_1["default"]
            .get(apiServerUrl + "/v1/linked-contents/" + bookId)
            .then(function (_a) {
            var data = _a.data;
            if (!types_1.isV2ResponseSuccess(data)) {
                return;
            }
            if (!data.data.linked_contents) {
                return;
            }
            var linkedContents = __spreadArrays(data.data.linked_contents.books, data.data.linked_contents.animations);
            var hasLinkedContentsExceptMe = linkedContents.some(function (content) {
                return types_1.isAnimationContent(content) || content.book_id !== "" + bookId;
            });
            if (!hasLinkedContentsExceptMe) {
                return;
            }
            _this.setState(function (state) { return (__assign(__assign({}, state), { linkedContents: [linkedContents] })); });
        });
    };
    Notice.parseNoticeType = function (result, item) {
        switch (item.type) {
            case ItemType.CURRENT_SERIAL_SCHEDULE: {
                var type = DisplayType.SCHEDULE;
                Array.isArray(result[type]) ? result[type].push(item) : result[type] = [item];
                return result;
            }
            case ItemType.DEPRECATED_NOTICE_LAFTEL_CONTENTS: {
                // Integrated with LinkedContents, ignoring...
                return result;
            }
            default: {
                var type = DisplayType.NOTICE;
                Array.isArray(result[type]) ? result[type].push(item) : result[type] = [item];
                return result;
            }
        }
    };
    Notice.prototype.hasChild = function () {
        return Object.values(this.state).some(function (v) { return v.length > 0; });
    };
    Notice.prototype.render = function () {
        var _a = this.state, schedule = _a.schedule, notices = _a.notices, events = _a.events, benefits = _a.benefits, linkedContents = _a.linkedContents;
        var _b = this.props, haveRidiSelectBookInSetBooks = _b.haveRidiSelectBookInSetBooks, setBookElementId = _b.setBookElementId, isRidiSelectBook = _b.isRidiSelectBook, ridiSelectDetailUrl = _b.ridiSelectDetailUrl;
        var bookId = this.context.bookId;
        return (React.createElement("li", { className: "BookDetailNotice" },
            this.hasChild() && React.createElement(React.Fragment, null,
                React.createElement(NoticeList_1.NoticeList, { header: "\uC5F0\uC7AC", type: "schedule", items: schedule }),
                React.createElement(NoticeList_1.NoticeList, { header: "\uACF5\uC9C0", type: "notices", items: notices }),
                React.createElement(NoticeList_1.NoticeList, { header: "\uD61C\uD0DD", type: "benefits", items: benefits }),
                React.createElement(NoticeList_1.NoticeList, { header: "\uC774\uBCA4\uD2B8", type: "events", items: events })),
            React.createElement(WaitFree_1.WaitFree, { bookId: bookId }),
            React.createElement(NoticeSelect_1.NoticeSelect, { haveRidiSelectBookInSetBooks: haveRidiSelectBookInSetBooks, setBookElementId: setBookElementId, isRidiSelectBook: isRidiSelectBook, ridiSelectDetailUrl: ridiSelectDetailUrl }),
            React.createElement(NoticeList_1.NoticeList, { header: "\uCD94\uCC9C", type: "linkedContents", items: linkedContents })));
    };
    Notice.contextType = BookDetailContext_1.BookDetailContext;
    return Notice;
}(React.Component));
exports.Notice = Notice;
;


/***/ }),

/***/ "ZczN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
exports.__esModule = true;
var React = __webpack_require__("SAdv");
var styled_1 = __webpack_require__("LJ3e");
var SetBookWrapper = styled_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  width: calc(100% + 2px);\n  bottom: 21%;\n  left: -1px;\n  height: 25px;\n  background: white\n    linear-gradient(\n      90deg,\n      rgba(0, 0, 0, 0.2) 0%,\n      rgba(0, 0, 0, 0.0001) 7.37%,\n      rgba(0, 0, 0, 0.0001) 92.26%,\n      rgba(0, 0, 0, 0.2) 100%\n    );\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  position: absolute;\n  width: calc(100% + 2px);\n  bottom: 21%;\n  left: -1px;\n  height: 25px;\n  background: white\n    linear-gradient(\n      90deg,\n      rgba(0, 0, 0, 0.2) 0%,\n      rgba(0, 0, 0, 0.0001) 7.37%,\n      rgba(0, 0, 0, 0.0001) 92.26%,\n      rgba(0, 0, 0, 0.2) 100%\n    );\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));
var LineDecoration = styled_1["default"].hr(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: block;\n  width: 100%;\n  border: 0;\n  position: relative;\n  height: 2px;\n  background: #1f8ce6;\n"], ["\n  display: block;\n  width: 100%;\n  border: 0;\n  position: relative;\n  height: 2px;\n  background: #1f8ce6;\n"])));
var SetLabel = styled_1["default"].span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: 13px;\n  line-height: 15px;\n  text-align: center;\n  letter-spacing: -0.373044px;\n  color: #333333;\n  padding: 0 6px;\n  flex-shrink: 0;\n  flex-grow: 0;\n"], ["\n  font-size: 13px;\n  line-height: 15px;\n  text-align: center;\n  letter-spacing: -0.373044px;\n  color: #333333;\n  padding: 0 6px;\n  flex-shrink: 0;\n  flex-grow: 0;\n"])));
var SetBookRenderer = function (props) {
    var setBookCount = props.setBookCount;
    if (!setBookCount) {
        return null;
    }
    return (React.createElement(SetBookWrapper, null,
        React.createElement(LineDecoration, null),
        React.createElement(SetLabel, null, Math.min(setBookCount, 999) + "\uAD8C \uC138\uD2B8"),
        React.createElement(LineDecoration, null)));
};
exports["default"] = SetBookRenderer;
var templateObject_1, templateObject_2, templateObject_3;


/***/ }),

/***/ "h+sG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
exports.__esModule = true;
exports.Popup = void 0;
var React = __webpack_require__("SAdv");
var rsg_1 = __webpack_require__("KKT9");
;
exports.Popup = React.forwardRef(function (_a, ref) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var _b = React.useState(false), isOpened = _b[0], setIsOpened = _b[1];
    var lockContentBase = function () { document.body.style.overflow = 'hidden'; };
    var unlockContentBase = function () { document.body.style.removeProperty('overflow'); };
    var open = function () { return setIsOpened(true); };
    var close = function () { return setIsOpened(false); };
    React.useEffect(function () {
        if (!isOpened) {
            return undefined;
        }
        var onEscapeClose = function (event) {
            if (event.key === 'Escape') {
                close();
            }
        };
        lockContentBase();
        window.addEventListener('keydown', onEscapeClose);
        return function () {
            unlockContentBase();
            window.removeEventListener('keydown', onEscapeClose);
        };
    }, [isOpened]);
    React.useImperativeHandle(ref, function () { return ({
        open: open,
        close: close
    }); });
    return (React.createElement(rsg_1.Popup, __assign({}, props, { active: isOpened, onCancel: close }), children));
});


/***/ }),

/***/ "h36S":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.BookTrackingWrapper = exports.getTrackingURI = void 0;
var React = __webpack_require__("SAdv");
var qs = __webpack_require__("ymdt");
var appendQueryString = function (href, data, options) {
    if (options === void 0) { options = {}; }
    var _a = href.split('?'), url = _a[0], queryStr = _a[1];
    var value = (options.overwrite
        ? __assign(__assign({}, (qs.parse(queryStr))), data) : __assign(__assign({}, data), (qs.parse(queryStr))));
    return url + qs.stringify(value, { addQueryPrefix: true });
};
exports.getTrackingURI = function (inputURI, params) {
    var sectionId = params.sectionId, sectionItemIdx = params.sectionItemIdx, sectionArg = params.sectionArg;
    return appendQueryString(inputURI, {
        _rdt_sid: sectionId.replace(/-/g, '_'),
        _rdt_idx: sectionItemIdx,
        _rdt_arg: sectionArg || undefined,
    }, { overwrite: true });
};
var pickTargetByThumbnail = function (elem) { return (elem.className && elem.className.includes('RSGBookThumbnail_CoverImage_Shadow')); };
var pickTargetByTitle = function (elem) { return (elem.className && elem.className.includes('RSGBookMetadata_Title')); };
var checkIsTarget = function (target) { return [
    pickTargetByThumbnail,
    pickTargetByTitle,
].reduce(function (p, picker) { return (p ? p : picker(target)); }, false); };
var BookTrackingWrapper = function (props) {
    var href = props.href, sectionId = props.sectionId, sectionItemIdx = props.sectionItemIdx, children = props.children;
    return (React.createElement("div", { onClick: function (e) {
            if (href && checkIsTarget(e.target)) {
                e.preventDefault();
                var trackingURI = exports.getTrackingURI(href, {
                    sectionId: sectionId,
                    sectionItemIdx: sectionItemIdx,
                });
                window.location.href = trackingURI;
            }
        } }, children));
};
exports.BookTrackingWrapper = BookTrackingWrapper;


/***/ }),

/***/ "i0Vv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
exports.__esModule = true;
var React = __webpack_require__("SAdv");
var styled_1 = __webpack_require__("LJ3e");
var FreeBookBadge = styled_1["default"].span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  border: 1px solid rgba(255, 255, 255, 0.4);\n  border-right: 0;\n  border-bottom: 0;\n  opacity: 0.9;\n  background: rgba(0, 0, 0, 0.7);\n  border-radius: 3px 0 0 0;\n  padding: 7px 6px 5px 6px;\n  color: white;\n  font-weight: bold;\n  font-size: 12px;\n  z-index: 3;\n  line-height: 12px;\n"], ["\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  border: 1px solid rgba(255, 255, 255, 0.4);\n  border-right: 0;\n  border-bottom: 0;\n  opacity: 0.9;\n  background: rgba(0, 0, 0, 0.7);\n  border-radius: 3px 0 0 0;\n  padding: 7px 6px 5px 6px;\n  color: white;\n  font-weight: bold;\n  font-size: 12px;\n  z-index: 3;\n  line-height: 12px;\n"])));
var FreeBookRenderer = function (props) {
    if (props.freeBookCount && props.freeBookCount > 0) {
        return (React.createElement(FreeBookBadge, null, "" + props.freeBookCount + props.unit + " \uBB34\uB8CC"));
    }
    return null;
};
exports["default"] = FreeBookRenderer;
var templateObject_1;


/***/ }),

/***/ "n8nK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
exports.__esModule = true;
exports.PortraitBook = exports.getMaxDiscountPercentage = exports.BadgeContainer = void 0;
var rsg_1 = __webpack_require__("KKT9");
var classNames = __webpack_require__("C7vi");
var React = __webpack_require__("SAdv");
var styled_1 = __webpack_require__("LJ3e");
var colors_1 = __webpack_require__("xP39");
var BookBadgeRenderer_1 = __webpack_require__("H8dE");
var FreeBookRenderer_1 = __webpack_require__("i0Vv");
var SetBookRenderer_1 = __webpack_require__("ZczN");
var lodash_1 = __webpack_require__("uin+");
var AuthorsWrapper = styled_1["default"].span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 12px;\n  line-height: 1.3em;\n  color: ", ";\n  margin-bottom: 2px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: block;\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  word-wrap: break-word;\n  white-space: normal;\n  word-break: keep-all;\n\n  @media (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    white-space: nowrap;\n  }\n"], ["\n  font-size: 12px;\n  line-height: 1.3em;\n  color: ", ";\n  margin-bottom: 2px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: block;\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  word-wrap: break-word;\n  white-space: normal;\n  word-break: keep-all;\n\n  @media (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    white-space: nowrap;\n  }\n"])), colors_1.slateGray60);
function AuthorAnchor(props) {
    var _a = props.author, id = _a.id, name = _a.name;
    return (React.createElement("a", { href: id
            ? "/author/" + id
            : "/search?q=" + encodeURIComponent(name) }, name));
}
function Authors(props) {
    var authors = props.authors;
    var len = authors.length;
    if (len === 0) {
        return null;
    }
    if (len === 1) {
        return React.createElement(AuthorAnchor, { author: authors[0] });
    }
    if (len === 2) {
        return (React.createElement(React.Fragment, null,
            React.createElement(AuthorAnchor, { author: authors[0] }),
            ', ',
            React.createElement(AuthorAnchor, { author: authors[1] })));
    }
    // len > 2
    return (React.createElement(React.Fragment, null,
        React.createElement(AuthorAnchor, { key: "0", author: authors[0] }),
        ', ',
        React.createElement(AuthorAnchor, { key: "1", author: authors[1] }), " \uC678 " + (len - 2) + "\uBA85"));
}
exports.BadgeContainer = styled_1["default"].div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  display: block;\n  top: -7px;\n  left: -7px;\n  z-index: 2;\n"], ["\n  position: absolute;\n  display: block;\n  top: -7px;\n  left: -7px;\n  z-index: 2;\n"])));
exports.getMaxDiscountPercentage = function (book) {
    if (!book) {
        return 0;
    }
    var singleBuyDiscountPercentage = lodash_1.get(book, 'price_info.buy.discount_percentage', 0);
    var singleRentDiscountPercentage = lodash_1.get(book, 'price_info.rent.discount_percentage', 0);
    var seriesBuyDiscountPercentage = lodash_1.get(book, 'series.property.is_serial', false) ? lodash_1.get(book, 'series.price_info.buy.discount_percentage', 0) : 0;
    var seriesRentDiscountPercentage = lodash_1.get(book, 'series.property.is_serial', false) ? lodash_1.get(book, 'series.price_info.rent.discount_percentage', 0) : 0;
    var excludeMax = [
        singleBuyDiscountPercentage,
        seriesBuyDiscountPercentage,
        singleRentDiscountPercentage,
        seriesRentDiscountPercentage,
    ].filter(function (dp) { return dp < 100; });
    var maxValue = Math.round(Math.max.apply(Math, excludeMax));
    if (maxValue >= 10) {
        return maxValue;
    }
    return 0;
};
function PortraitBook(props) {
    var className = props.className, thumbnailSize = props.thumbnailSize, book = props.book, genre = props.genre;
    // RSG 코드 내에 썸네일 링크가
    // /v2/Detail?id={bId} 로 박힌 상태. 일단 유지하고 페이지 전체를 반응형으로 변경할 때 RSG 사용하지 않기
    var mergedAuthors = book && book.authors && book.authors.filter(function (author) { return ['author', 'comic_author', 'story_writer', 'illustrator', 'original_author', 'editor'].includes(author.role); });
    var singlePriceInfo = book.price_info;
    var seriesPriceInfo = lodash_1.get(book, 'series.price_info', null);
    var isSingleRentable = !!singlePriceInfo.rent;
    var isSeriesRentable = !!lodash_1.get(seriesPriceInfo, 'rent', null) && lodash_1.get(book, 'book.series.property.is_serial', false);
    return (React.createElement(rsg_1.Book, { className: classNames('RSGBook-preset-portrait', className), style: { width: thumbnailSize + "px" }, 
        // @ridi/rsg book dto 와 맞지 않음
        dto: book }, function (_a) {
        var Thumbnail = _a.Thumbnail, Metadata = _a.Metadata;
        return (React.createElement(React.Fragment, null,
            React.createElement(Thumbnail.wrapper, { thumbnailSize: thumbnailSize },
                React.createElement(Thumbnail.coverImage, null),
                React.createElement(Thumbnail.adultOnlyBadge, null),
                React.createElement(exports.BadgeContainer, null,
                    React.createElement(BookBadgeRenderer_1["default"], { isRentable: isSingleRentable
                            || isSeriesRentable
                                && ['general', 'romance', 'bl'].includes(genre), isWaitFree: lodash_1.get(book, 'series.property.is_wait_free', false), discountPercentage: exports.getMaxDiscountPercentage(book) })),
                React.createElement(FreeBookRenderer_1["default"], { freeBookCount: lodash_1.get(seriesPriceInfo, 'rent.free_book_count', 0)
                        || lodash_1.get(seriesPriceInfo, 'buy.free_book_count', 0)
                        || 0, unit: lodash_1.get(book, 'series.property.unit', '권') }),
                React.createElement(SetBookRenderer_1["default"], { setBookCount: lodash_1.get(book, 'setbook.member_books_count', 0) })),
            React.createElement(Metadata.wrapper, null,
                React.createElement("a", { href: "/books/" + props.book.id, className: "RSGBookMetadata_Title" }, lodash_1.get(props.book, 'series.property.title', props.book.title.main)),
                React.createElement(AuthorsWrapper, null,
                    React.createElement(Authors, { authors: Array.isArray(mergedAuthors) ? mergedAuthors : [] })))));
    }));
}
exports.PortraitBook = PortraitBook;
;
var templateObject_1, templateObject_2;


/***/ }),

/***/ "pM3A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("SAdv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  d: "M6.5 12.75a6.25 6.25 0 100-12.5 6.25 6.25 0 000 12.5zm-.625-5v-5h1.25v5h-1.25zm0 2.5V9h1.25v1.25h-1.25z",
  fill: "#D1D5D9"
});

var SvgExclamation = function SvgExclamation(props) {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    width: 13,
    height: 13,
    fill: "none"
  }, props), _ref);
};

/* harmony default export */ __webpack_exports__["default"] = (SvgExclamation);

/***/ }),

/***/ "uYbG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
exports.NoticeBenefitItem = void 0;
var React = __webpack_require__("SAdv");
var classnames_1 = __webpack_require__("C7vi");
var rsg_1 = __webpack_require__("KKT9");
exports.NoticeBenefitItem = function (_a) {
    var url = _a.url, title = _a.title, detail_message = _a.detail_message;
    return (React.createElement("li", { className: classnames_1["default"]('BookDetailNotice_List_Item') },
        React.createElement("a", { href: url },
            React.createElement("div", { className: "BookDetailNotice_List_Item_Title" }, title),
            detail_message.length > 0 && (React.createElement("div", { className: classnames_1["default"]('BookDetailNotice_List_Item_Content', 'BookDetailNotice_List_Item_EventPeriod', 'BookDetailNotice_List_Item_BookBenefit') },
                React.createElement("span", null, detail_message))),
            React.createElement(rsg_1.Icon, { className: "BookDetailNotice_List_Item_ArrowIcon", name: "arrow_2_right" }))));
};


/***/ }),

/***/ "w0AC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
exports.WaitFree = void 0;
/* tslint:disable:member-access */
var classNames = __webpack_require__("C7vi");
var React = __webpack_require__("SAdv");
var axios_1 = __webpack_require__("gI3o");
var Exclamation_svg_1 = __webpack_require__("pM3A");
var styled_1 = __webpack_require__("LJ3e");
var WaitFreeTimer_1 = __webpack_require__("3XIZ");
// @ts-ignore
var StyledExclamation = styled_1["default"](Exclamation_svg_1["default"])(templateObject_1 || (templateObject_1 = __makeTemplateObject(["margin-left: 5.25px"], ["margin-left: 5.25px"])));
var WaitFree = /** @class */ (function (_super) {
    __extends(WaitFree, _super);
    function WaitFree(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            rentDays: 0,
            rentVolume: 0,
            unavailableRecentCount: 0,
            intervalHours: 0,
            availableMaxVolume: null,
            availableAt: null,
        };
        _this.handleRemoveAvailableAt = function () {
            _this.setState({ availableAt: null });
        };
        return _this;
    }
    // TODO: use redux store
    WaitFree.prototype.componentDidMount = function () {
        var _this = this;
        axios_1["default"]
            .get("/api/wait-free/" + this.props.bookId)
            .then(function (_a) {
            var data = _a.data;
            _this.setState({
                availableAt: data.available_at,
                rentDays: data.rent_days,
                rentVolume: data.rent_volume,
                unavailableRecentCount: data.unavailable_recent_count,
                intervalHours: data.interval_hours,
                availableMaxVolume: data.available_max_volume,
            });
            window.dispatchEvent(new CustomEvent('updateWaitFreePopupData', {
                detail: {
                    rentDays: data.rent_days,
                    rentVolume: data.rent_volume,
                    unavailableRecentCount: data.unavailable_recent_count,
                    availableMaxVolume: data.available_max_volume,
                },
            }));
        });
    };
    WaitFree.prototype.onClickWaitFreeHelp = function (interval) {
        var _a = this.state, rentDays = _a.rentDays, rentVolume = _a.rentVolume, unavailableRecentCount = _a.unavailableRecentCount;
        window.dispatchEvent(new CustomEvent('toggleWaitFreeHelpPopup', {
            detail: {
                interval: interval,
                rentDays: rentDays,
                rentVolume: rentVolume,
                unavailableRecentCount: unavailableRecentCount,
            },
        }));
    };
    WaitFree.prototype.renderIntervalText = function () {
        var intervalHours = this.state.intervalHours;
        var dayCount = 0;
        var hourCount = intervalHours % 24;
        if (intervalHours / 24 > 0) {
            dayCount = Math.floor(intervalHours / 24);
        }
        return "" + (dayCount > 0 ? dayCount + "\uC77C " : '') + (hourCount !== 0 ? hourCount + "\uC2DC\uAC04" : '');
    };
    WaitFree.prototype.renderWaitFreeTimer = function () {
        var _a = this.state, intervalHours = _a.intervalHours, availableAt = _a.availableAt;
        if (availableAt) {
            return (React.createElement(WaitFreeTimer_1.WaitFreeTimer, { intervalHours: intervalHours, availableAt: availableAt, close: this.handleRemoveAvailableAt }));
        }
        return null;
    };
    WaitFree.prototype.render = function () {
        var _this = this;
        var _a = this.state, rentVolume = _a.rentVolume, intervalHours = _a.intervalHours, availableAt = _a.availableAt;
        var _b = global.Ridi.globals, isLoggedIn = _b.isLoggedIn, isMobile = _b.isMobile;
        var interval = this.renderIntervalText();
        return intervalHours ? (React.createElement("li", null,
            React.createElement("div", { className: isMobile ? 'BookDetailWaitFree_Mobile' : 'BookDetailWaitFree' },
                React.createElement("div", { className: classNames('BookDetailNotice_List_Header', "BookDetailNotice_List_Header-WaitFree") }, "\uB9AC\uB2E4\uBB34"),
                React.createElement("div", { className: "BookDetailWaitFree_Header" },
                    interval,
                    "\uB9C8\uB2E4 ",
                    rentVolume,
                    "\uD3B8 \uAE30\uB2E4\uB9AC\uBA74 \uBB34\uB8CC"),
                React.createElement("button", { className: "BookDetailWaitFree_GuideButton", onClick: function () { return _this.onClickWaitFreeHelp(interval); } },
                    React.createElement(StyledExclamation, null)),
                !availableAt && isLoggedIn && (React.createElement("span", { className: "BookDetailWaitFree_Available" }, "\uBB34\uB8CC \uC774\uC6A9 \uAC00\uB2A5"))),
            this.renderWaitFreeTimer())) : null;
    };
    return WaitFree;
}(React.Component));
exports.WaitFree = WaitFree;
var templateObject_1;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("Pkug")))

/***/ }),

/***/ "zCUy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
var _a, _b;
exports.__esModule = true;
exports.BookDetailContext = void 0;
var react_1 = __webpack_require__("SAdv");
//@ts-ignore
var ADULT_COVER_URL = ((_b = (_a = global.Ridi) === null || _a === void 0 ? void 0 : _a.globals) === null || _b === void 0 ? void 0 : _b.staticUrl) + '/books/dist/images/book_cover/cover_adult.png';
exports.BookDetailContext = react_1.createContext({
    bookId: -1,
    categoryName: '',
    bookApiUrl: 'https://book-api.ridibooks.com',
    apiServerUrl: 'https://api.ridibooks.com',
    isVerifiedAdult: false,
    adultBookCover: ADULT_COVER_URL,
    featureGuard: {},
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("Pkug")))

/***/ })

},["UE1o"]);


// WEBPACK FOOTER //
// book_detail.min.js